module.exports = __webpack_public_path__ + "static/media/Voyage soffa 4-sits cozy grön detalj 2024 4.71db43c4.jpg";